






































































































































































































































































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { ReviewForm, ReviewEntity } from "@/entities";
import { State, Action, Getter } from "vuex-class";
import AuditComponent from "@/components/common/AuditInfo/AuditInfo.vue";
import * as _ from "lodash";
import { AppConstants as _app } from "@/shared/app.constants";
import { Locales } from "@/i18n/locales";

const namespace: string = "reviewForm";

@Component({
  components: {
    AuditComponent,
  },
})
export default class ReviewFormComponent extends Vue {
  @State(namespace) review!: ReviewForm;
  @State("reviewExternal") reviewEntity: ReviewEntity;
  @Action("getTemplate", { namespace }) getTemplate: any;
  @Action("getData", { namespace }) getData: any;
  @Action("saveReviewData", { namespace }) saveData: any;
  @Action("submit", { namespace }) submit: any;
  @Action("getCategories", { namespace }) getCategories: any;
  @Action("showNotification", { namespace: "application" }) notify: any;
  @Getter("_appUser", { namespace: "RootApp" }) _username!: string;

  reviewId: number = 0;
  //overallScore = 0;
  categoryList = [];
  modelData = {};
  applicationInfo = {};
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  mounted() {
    // get the templates..
    this.getTemplate(1);
    // if (this.reviewEntity && this.reviewEntity.externalReviewId) {
    // } else {
    //   this.$router.push({
    //     name: "dashboard",
    //   });
    // }
  }

  /** pdf download */
  download() {
    let entity = this.$router.currentRoute.params['entity'].toString();
    // this.$services.tagReviewReport.generate({
    //   "data": this.getFormData(),
    //   "categories": this.categoryList,
    //   "applicationInfo": this.applicationInfo,
    //   "reviewer": this._username,
    //   "user": this._username
    // });
    this.$services.review.getReportData(this.review.reviewId, entity)
      .then((resp) => {
        if (resp.status >= 200 && resp.status < 300) {
          this.$services.tagReviewReport.generate({
            data: this.getFormData(),
            categories: this.categoryList,
            metadata: resp.data.metadata,
            user: this._username,
          });
        }
        // this.$services.reviewPdf.print(this.getFormData(), this.categoryList, this.applicationInfo);
      });
  }

  /** Application Review */
  getReviewData(reviewerId: number, applicationId: string, entity: string) {
    // this.reviewId = id;
    var self = this;

    this.getData({
      reviewerId: reviewerId,
      applicationId: applicationId,
      language: localStorage.getItem("language"),
      entity: entity,
    }).then((data) => {
        this.reviewId = data.review.reviewId;
        this.categoryList = data.categories;
        this.transform();
        this.applicationInfo = data.application;
        this.review.override = true;
    });
  }

  /** transform model data to the desired format */

  transform() {
    this.modelData = this.categoryList.reduce((obj: any, tmpl: any) => {
      obj[tmpl.CategoryId] = { rating: 0, reviewComment: "" };
      if (this.review.reviews) {
        const review = this.review.reviews.find(
          (x) => x.categoryId == tmpl.CategoryId
        );
        if (review)
          obj[tmpl.CategoryId] = {
            rating: review.rating,
            reviewComment: review.reviewComment,
          };
      }
      return obj;
    }, {});
  }

  /** back to dashboard */
  back() {
    this.$router.push({
      name: "dashboard",
    });
  }

  /*** validate form data before submit */
  validate() {
    let msg = "<ol>",
      valid = true;
    if (this.review.override && !this.review.comment) {
      valid = false;
      msg += "<li>Please enter detailed comment before submitting.</li>";
    }
    if (this.review.override && !this.review.recommendation) {
      valid = false;
      msg += "<li>Please provide recommendation before submitting.</li>";
    }
    const reviews = Object.keys(this.modelData).reduce(
      (out: any, key: string) => {
        out.push(
          Object.assign({}, { categoryId: parseInt(key) }, this.modelData[key])
        );
        return out;
      },
      []
    );

    const maxScore = reviews.length * 5;
    let isHaveNull = _.some(reviews, (item) => item.rating == 0);
    if (isHaveNull) {
      valid = false;
      msg += "<li>Please rate all categories.</li>";
    }
    if (this.review.totalScore > maxScore) {
      valid = false;
      msg += `<li>Total score is greater than possible max value: ${maxScore}.</li>`;
    }
    let skippedComment = _.some(
      reviews,
      (item) => item.reviewComment.trim().length == 0
    );
    if (skippedComment) {
      valid = false;
      msg += "<li>Please provide comment on all categories.</li>";
    }
    msg += "</ol>";
    if (!valid) {
      this.notify({ text: msg, isHtml: true, color: "error" });
    }
    // this.review.notification.text = msg;
    // this.review.notification.color = 'error';
    return valid;
  }

  /** get the computed property overall score */
  get overallScore() {
    return Object.keys(this.modelData).reduce((sum, key) => {
      sum += this.modelData[key].rating;
      return sum;
    }, 0);
  }

  /** computed property recommendation */

  get recommendation() {
    // TO DO: Should come from configuartion
    const minRating = 3;
    const categoryCnt = Object.keys(this.modelData).length;
    return this.overallScore < categoryCnt * minRating ? this.$t("No") : this.$t("Yes");
  }

  /** Transform and get the form data */

  getFormData() {
    const reviews = Object.keys(this.modelData).reduce(
      (out: any, key: string) => {
        out.push(
          Object.assign({}, { categoryId: parseInt(key) }, this.modelData[key])
        );
        return out;
      },
      []
    );
    let form = {
      reviews,
      override: this.review.override,
      comment: this.review.comment,
      totalScore: this.overallScore,
      overallRating: this.review.overallRating,
      recommendation: this.review.recommendation,
      applicationId: this.review.applicationId,
      reviewerId: this.review.reviewerId,
      version: this.review.version,
      auditInfo: this.review.auditInfo,
    };

    return form;
  }

  /** Save the review in draft mode */

  saveReviewData() {
    const data = this.getFormData();
    let entityType = this.$route.params.entity;
    this.saveData({entity: entityType, id: this.reviewId, data });
  }
  /** override */
  override() {
    this.review.override = true;
  }
  /** cancel override */
  cancelOverride() {
    this.review.override = false;
    this.review.totalScore = 0;
    this.review.overallRating = undefined;
    this.review.recommendation = undefined;
    this.review.comment = undefined;
  }

  /** open a read only view of application in new tab */
  openApplication() {
    if (this.$route.params.entity === 'ConceptNote') {
      let routeData = this.$router.resolve({
        name: "viewConceptNote",
        params: {
          conceptNoteId: this.review.applicationId,
          section: "technicalApplication",
        },
      });
      
      window.open(routeData.href, "_blank");
    } else {
      let routeData = this.$router.resolve({
        name: "viewApplication",
        params: {
          appId: this.review.applicationId,
          section: "technicalApplication",
        },
      });

      window.open(routeData.href, "_blank");
    }
  }

  /** Submit form */
  submitForm() {
    const valid = this.validate();
    let entityType = this.$route.params.entity;
    if (!valid) {
      // this.showMessage();
    } else {
      const data = this.getFormData();
      this.submit({entity: entityType, id: this.reviewId, data }).then((data) => {
        if (data) {
          const key: any = "reviewSubmitted";
          this.$router.push({
            name: "genericNotification",
            query: { msgId: key },
          });
        }
      });
    }
  }

  /** watch method */
  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(changedRoute: any) {
    if (changedRoute && changedRoute.name === "reviewApplication") {
      let reviewerId = changedRoute.params.reviewerId;
      let applicationId = changedRoute.params.applicationId;
      let entity = changedRoute.params.entity;

      this.getReviewData(reviewerId, applicationId, entity);

      // if (this.reviewEntity && this.reviewEntity.externalReviewId) {
      //   this.reviewId = this.reviewEntity.externalReviewId;
      //   this.getReviewData(this.reviewEntity.externalReviewId);
      // }
    }
  }
}
